import { render, staticRenderFns } from "./CheckboxGroupBuilder.vue?vue&type=template&id=4c3c1d7e&"
import script from "./CheckboxGroupBuilder.vue?vue&type=script&lang=ts&"
export * from "./CheckboxGroupBuilder.vue?vue&type=script&lang=ts&"
import style0 from "./CheckboxGroupBuilder.vue?vue&type=style&index=0&id=4c3c1d7e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports